import React from "react";
import styles from "./styles";
import { withStyles } from "@material-ui/core/styles";
import {
  DialogActions,
  Button,
  Typography,
  Divider,
  DialogContent,
  Dialog,
} from "@material-ui/core";
import appConstants from "../../../../../../appConstants";
import { observer, inject } from "mobx-react";
import PickupShipmentCard from "./PickupShipmentCard/index";
import { withUserProfile } from "../../../../../../userProfile/userProfileContext";
import { compose } from "recompose";
import PickupDetails from "./PickupDetails";
import CustomConfirmationDialog from "../common/CustomConfirmationDialog";
import {
  getDefaultPickupStopInfo,
  getDefaultShipmentData,
  getCountryList,
  getPriorityShipmentList,
  getSortedShipmentsByPickupNumber,
  getPickupIdToNumberMap,
  getNoFreightPickupIds
} from "./util";
import ShipmentBadgeList from "../common/ShipmentBadgeList";
import {
  getDateWithUtcHoursAndMinFromTimeString,
} from '@dataGrid/gridUtilities';
import PickupDialogActions from "./PickupDialogActions";
import { postData, getDataWithQueryString } from "../../../../../../api/componentAPIs";
import Events from "../../../../../../utilities/EventEmitter";
import { withSnackbar } from "notistack";
import DialogTitle from "./DialogTitle";
import { getAccessorialsAfterExclusion } from "./../common/AccessorialUtils";
import {
  getDefaultStopTimeInfo,
  getStopTimeFieldError,
  getStopTimeErrorInfo,
  isStopTimeDetailsInValid,
  getStopTimeWithOffset,
} from "../EditStopDialog/util";
import { RMAXLogger } from "../../../../../../services/LoggerService/RMAXLogger";
import { withProValidationHOC } from "./ProNumberValidation";
import constants from "./constants";
import { sanitizeObject } from "../../../../../../utilities/dataUtils";
import { withAppConfig } from "../../../../../../appConfigContext";
import NoFreightReasonDialogContent from "./NoFreightReasonDialogContent";

@inject("DispatchStore")
@observer
class ProcessPickupStopDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editBillsDataArray: getDefaultPickupStopInfo({
        getProNumber: this.props.proValidation.getProNumber,
        stopData: this.props.stopData,
        proNumberLength: this.props.DispatchStore.staticClientData?.clientCodes?.proNumberLength,
        defaultCountry: this.props.configJSON.defaultCountry,
      }),
      errorMessage: null,
      allStatusRadioClicked: false,
      pickupInfo: this.getPickupInfo(),
      pickupErrorInfo: this.getPickupErrorInfo(),
      isIncompleteEntryExist: false,
      stopTimeInfo: this.getStopTimeInfo(),
      consigneeList: [],
      incompletePickups: [],
      showNoFreightReasonContent: false
    };
    this.inputRefs = [];
    this.accessorialList = this.props.DispatchStore.pickupAccessorials.map(
      (accessorial) => {
        return { isChecked: false, ...accessorial };
      }
    );
    this.priorityShipmentsList = getPriorityShipmentList(
      this.props.DispatchStore.priorityShipmentOptions
    );
    this.packageTypeList = this.props.DispatchStore.packageCodes;
    this.countryList = getCountryList();
    this.pickupDetailsRef = React.createRef();
    this.limitedAccessList = this.props.DispatchStore.limitedAccessList;
    this.enableNoFreightCode= props.configJSON.enableNoFreightCode;
    this.modalMessage = this.props.isAddProToCompletedPickupFlow ? constants.ADD_PRO_TO_PICKUP : constants.PROCESS_PICKUP;
    this.noFreightCodes= this.getNoFreightCodes();
  }

  componentDidUpdate(prevProps) {
    if (this.props.isDriverArrived !== prevProps.isDriverArrived) {
      this.setNewArrivalStopTime();
    }
  }

  componentDidMount() {
    Events.on("PickupCompleted", this.showPickupCompletedStatus);
    this.getShipperConsigneeList();
  }

  componentWillUnmount() {
    Events.removeListener("PickupCompleted", this.showPickupCompletedStatus);
  }

  getShipperConsigneeList = () => {
    getDataWithQueryString(
      "GetShipperConsignee",
      `terminalCode=${this.props.userData.userProfile.terminal.code}&driverId=${this.props.routeData.driverId}`
    )
      .then((response) => {
        if (response && response.status === 200) {
          this.setState({consigneeList: response.data})
        } else {
          this.setState({consigneeList: []})
        }
      })
      .catch((_error) => {
        this.setState({consigneeList: []})
      });
  };

  getStopTimeInfo = () => {
    const { stopData, isDriverArrived, isAddProToCompletedPickupFlow } = this.props;
    if (isAddProToCompletedPickupFlow) {
      return {
        stopTime: {
          arrivalTime: stopData.actualArrivalTime,
          departureTime: stopData.actualDepartureTime,
        },
        stopTimeError: {
          arrivalTime: null,
          departureTime: null,
        },
      }
    }
    return getDefaultStopTimeInfo({isDriverArrived, actualArrivalTime:stopData.actualArrivalTime});
  }

  setNewArrivalStopTime = () => {
    const {
      isDriverArrived,
      stopData: { actualArrivalTime },
    } = this.props;
    this.setState((prevState) => ({
      ...prevState,
      stopTimeInfo: {
        ...prevState.stopTimeInfo,
        stopTime: {
          ...prevState.stopTimeInfo.stopTime,
          arrivalTime:
            isDriverArrived && actualArrivalTime
              ? getDateWithUtcHoursAndMinFromTimeString(actualArrivalTime)
              : null,
        },
      },
    }));
  };

  getPickupInfo = () => {
    return {
      isShipperLoadAndCount: this.props.stopData.isSLC ?? false,
      isNoFreight: false,
      isDriverAllowedInside: true,
      customerName: "",
      noFreightCode: null,
      trailerSpaceFilled: 0,
    };
  };
  getPickupErrorInfo = () => {
    return {
      customerName: null,
      isShipperLoadAndCount: null,
      isNoFreight: null,
      isDriverAllowedInside: null,
      trailerSpaceFilled: null,
      noFreightCode: null
    };
  };

  handleStopTimeChange = (name) => (value) => {
    const stopTime = {
      ...this.state.stopTimeInfo.stopTime,
      [name]: value
    };
    const prevStopTimeError = this.state.stopTimeInfo.stopTimeError;
    const stopTimeError = {
      arrivalTime:
        name === 'arrivalTime'
          ? getStopTimeFieldError({
            field: 'arrivalTime',
            value: stopTime.arrivalTime,
            stopTimeInfo: stopTime
          })
          : prevStopTimeError.arrivalTime,
      departureTime:
        name === 'departureTime' || stopTime.departureTime
          ? getStopTimeFieldError( {
            field: 'departureTime',
            value: stopTime.departureTime,
            stopTimeInfo: stopTime
          })
          : prevStopTimeError.departureTime
    };
    this.setState({
      stopTimeInfo: {
        stopTime,
        stopTimeError
      }
    });
  };

  updateStop = (apiName, requestParams) => {
  const sanitizedParams =  sanitizeObject(requestParams);
  this.showLoaderDialog();
    RMAXLogger.info("Complete_Pickup", {
      action: `${apiName} Applied`,
      eventData: sanitizedParams
    });
    postData(apiName, sanitizedParams).then((response) => {
      if (response && Math.trunc(response.status / 100) !== 2) {
        this.handleError(response.status);
      }
    }, () => {
      this.handleError();
    });
  };

  handleError = (statusCode) => {
    this.hideLoaderDialog();
    if (statusCode === 403) {
      return;
    }
    this.showFailedNotification(); 
  }

  showPickupCompletedStatus = (data) => {
    const { success } = data;
    if (success) {
      this.props.enqueueSnackbar(this.modalMessage.MESSAGES.SUCCESS, {
        variant: "success",
      });
      this.props.handleClose();
    } else {
      this.showFailedNotification();
    }
    this.hideLoaderDialog();
  };


  showLoaderDialog = () => {
    this.props.glEventHub.emit("DispatchEvents", "ShowLoaderDialog", [
      this.modalMessage.LOADER,
    ]);
  };

  hideLoaderDialog = () => {
    this.props.glEventHub.emit("DispatchEvents", "HideLoaderDialog", []);
  };

  showFailedNotification = () => {
    this.props.enqueueSnackbar(this.modalMessage.MESSAGES.FAILED, {
      variant: "error",
    });
  };

  completePickup = (isNoFreightPresent = false) => {
    const { editBillsDataArray, isIncompleteEntryExist } = this.state;
    this.setState({
      isIncompleteEntryExist: false
    })
    const bills = isIncompleteEntryExist || isNoFreightPresent
      ? this.getCompletedPros()
      : editBillsDataArray;
    this.updatePickupStop(bills);
  };

  handleCompletePro = (shipmentId, updatedData) => {
    let updatedArr = [];
    this.state.editBillsDataArray.forEach((shipment) => {
      if (shipment.shipmentId === shipmentId) {
        shipment.editInfo = { ...updatedData };
        shipment.isUpdatedAtLeastOnce = true;
        shipment.pickupStatus = appConstants.PICKUP_STATUS.COMPLETED;
        shipment.openEditMode = false;
        updatedArr.push(shipment);
      } else {
        updatedArr.push(shipment);
      }
    });
    this.setState({
      editBillsDataArray: updatedArr,
      isAddProClicked: false,
    });
  };

  clearEnteredProData = (name, value) => {
    const defaultStopsData = getDefaultPickupStopInfo({
      getProNumber: this.props.proValidation.getProNumber,
      stopData: this.props.stopData,
      proNumberLength: this.props.DispatchStore.staticClientData?.clientCodes?.proNumberLength,
      defaultCountry: this.props.configJSON.defaultCountry,
  });
    this.setState((prevState) => ({
      editBillsDataArray: defaultStopsData,
      isAddProClicked: false,
      pickupInfo: {
        ...prevState.pickupInfo,
        [name]: value,
      },
    }));
  };

  handlePickupLevelData = (name) => (value) => {    
    if (name === "isNoFreight") {
      this.clearEnteredProData(name, value);
    } else {
      if(name === "noFreightCode"){
        value = value?.value ?? null;
      }
      this.setState((prevState) => ({
        pickupInfo: {
          ...prevState.pickupInfo,
          [name]: value,
        },
        pickupErrorInfo: {
          ...prevState.pickupErrorInfo,
          [name]: prevState.pickupInfo.isNoFreight
            ? this.getNoFreightEntryFieldError(name, value)
            : null,
        },
      }));
    }
  };

  getExcessiveShipment = (value) => {
    switch (value) {
      case appConstants.EXCESSIVE_SHIPMENT.YES:
        return "1";
      case appConstants.EXCESSIVE_SHIPMENT.NO:
        return "0";
      default:
        return appConstants.EXCESSIVE_SHIPMENT.CAN_NOT_SEE;
    }
  };
  getAccessorialsArray = (editInfo) => {
    const { accessorialExclusionList } =
      this.props.DispatchStore.getStaticClientData().clientCodes;
    const selectedAccessorials = editInfo.accessorials
      .filter((accessorial) => accessorial.isChecked)
      .map((accessorial) => accessorial.name);
    return selectedAccessorials.length === 0
      ? selectedAccessorials
      : getAccessorialsAfterExclusion(this.props.configJSON.proValidation)({
        selectedAccessorials,
        accessorialExclusionList,
        isLiftgateTrailer: this.props.routeData.trailer.isLiftGate,
      });
  };

  getValidPackageItems = (packagingItems) => {
    return packagingItems.filter(i => (i.hu || i.hu === 0) && i.packageCode);
  }

  populateRequestData = (shipment) => {
    return {
      ...shipment,
      accessorials: this.getAccessorialsArray(shipment),
      excessiveLength: shipment.excessiveProLength || 0,
      excessiveLengthInches: shipment.excessiveLengthInches || 0,
      excessiveLengthShipment: this.getExcessiveShipment(
        shipment.isExcessiveLength
      ),
      weight: parseInt(shipment.weight),
      pieces: parseInt(shipment.pieces),
      packageDetails: this.getValidPackageItems(shipment.packagingItems),
      packagingItems: undefined,
      isProPreAssigned: undefined,
      isExcessiveLength: undefined,
      excessiveProLength: undefined, // undefined properties are not required as part of request data
      rmaxShipperCode: this.props.stopData.isWarehousePickup ? shipment.rmaxShipperCode : null,
    };
  };

  updatePickupStop = (completedProsArray) => {
    const {
      routeData,
      stopData,
      userData: {
        userProfile: { terminal }
      }
    } = this.props;
    const {
      pickupInfo: {
        isShipperLoadAndCount,
        isDriverAllowedInside,
      },
      stopTimeInfo: { stopTime },
      incompletePickups
    } = this.state;
    const { arrivalTime, departureTime } = getStopTimeWithOffset(stopTime, terminal.offset);
    let finalArr = [];
    completedProsArray.forEach((shipment) => {
      finalArr.push(this.populateRequestData(shipment.editInfo));
    });
    const updateProData = {
      driverId: routeData.driverId,
      terminalCode: terminal.code,
      routeId: routeData.routeId,
      stopId: stopData.stopId,
      pickupId: stopData.pickupId,
      isSLC: isShipperLoadAndCount,
      isDriverAllowedInside,
      arrivalTime,
      departureTime,
      incompletePickups,
      trailerSpaceFilled: 0,// defaulting to 0 since dispatcher doesn't need add this information 
      shipments: [...finalArr],
    };
    this.updateStop("UpdatePickupStop", updateProData);
  };

  handleAddProToCompletedPickup = () => {
    const { routeData, stopData, userData } = this.props;
    let finalArr = [];
    const { editBillsDataArray } = this.state;
    const isIncompleteStopExists = editBillsDataArray.some(
      (shipment) => shipment.pickupStatus === appConstants.PICKUP_STATUS.WAITING
    );
    if (isIncompleteStopExists) {
      this.setState({
        isIncompleteEntryExist: true,
      });
      return;
    }
    editBillsDataArray.forEach((shipment) => {
      if (!shipment.isCompletedPro) {
        finalArr.push(this.populateRequestData(shipment.editInfo));
      }
    });
    const addProData = {
      driverId: routeData.driverId,
      terminalCode: userData.userProfile.terminal.code,
      routeId: routeData.routeId,
      stopId: stopData.stopId,
      pickupId: stopData.pickupId,
      shipments: [...finalArr],
    };
    this.updateStop("AddProToCompletedPickup", addProData);
  };

  handleSubmit = (pickupType) => {
    if (pickupType === "noFreight") {
      this.handleNoFreightEntry();
    } else if (this.props.stopData.isStopCompleted) {
      this.handleAddProToCompletedPickup();
    } else {
      const errorInfo = this.getErrorInfo();
      const error = Object.values(errorInfo).filter((value) => value).length;
      const stopTimeError = this.getStopTimeError();
      if (error && stopTimeError) {
        return;
      }
      const { editBillsDataArray } = this.state;
      const isIncompleteStopExists = editBillsDataArray.some(
        (shipment) =>
          shipment.pickupStatus === appConstants.PICKUP_STATUS.WAITING
      );
      if (isIncompleteStopExists && !stopTimeError) {
        this.setState({
          isIncompleteEntryExist: true,
        });
        return;
      } else {
        !stopTimeError && this.completePickup();
      }
    }
  };

  getStopTimeError = () => {
    const stopTimeDetailsInfo = getStopTimeErrorInfo(
      this.state.stopTimeInfo.stopTime
    );
    this.setState({
      stopTimeInfo: stopTimeDetailsInfo,
    });
    return isStopTimeDetailsInValid(stopTimeDetailsInfo);
  };

  handleNoFreightEntry = () => {
    const { routeData, stopData, userData: { userProfile: { terminal } } } = this.props;
    const { pickupInfo, stopTimeInfo: { stopTime } } = this.state;
    const { arrivalTime, departureTime } = getStopTimeWithOffset(stopTime, terminal.offset);
    const errorInfo = this.getNoFreightEntryErrorInfo();
    const error = Object.values(errorInfo).filter((value) => value).length;
    const stopTimeError = this.getStopTimeError();
    if (!error && !stopTimeError) {
      const updateProData = {
        driverId: routeData.driverId,
        terminalCode: terminal.code,
        routeId: routeData.routeId,
        stopId: stopData.stopId,
        pickupId: stopData.pickupId,
        contactName: pickupInfo.customerName,
        isDriverAllowedInside: pickupInfo.isDriverAllowedInside,
        arrivalTime,
        departureTime,
        ...(this.enableNoFreightCode && { noFreightCode: pickupInfo.noFreightCode }),
      };
      this.updateStop("NoFreightPickedUp", updateProData);
    }
  };

  getNoFreightEntryFieldError = (field, value) => {
    if (field === "customerName") {
      return value && value.trim() ? null : constants.VALIDATION.CUSTOMER_NAME;
    }
  };

  getNoFreightEntryErrorInfo = () => {
    let errorInfo = {};
    Object.keys(this.state.pickupInfo).forEach((fieldName) => {
      errorInfo[fieldName] = this.getNoFreightEntryFieldError(
        fieldName,
        this.state.pickupInfo[fieldName]
      );
    });
    this.setState({
      pickupErrorInfo: errorInfo,
    });
    return errorInfo;
  };

  getCompletedPros = () => {
    const { editBillsDataArray } = this.state;
    return editBillsDataArray.filter(
      (shipment) =>
        shipment.pickupStatus === appConstants.PICKUP_STATUS.COMPLETED
    );
  };
  isSubmitDisabled = () => {
    const { editBillsDataArray } = this.state;
    const incompleteProsArray = editBillsDataArray.filter((shipment) =>
      shipment.isCompletedPro
        ? shipment.pickupStatus === appConstants.PICKUP_STATUS.COMPLETED
        : shipment.pickupStatus === appConstants.PICKUP_STATUS.WAITING
    );
    return incompleteProsArray.length === editBillsDataArray.length;
  };


  editProClicked = () => {
    this.setState({
      isAddProClicked: true,
    });
  };
  addPro = () => {
    const proNumberLength = this.props.DispatchStore.staticClientData?.clientCodes?.proNumberLength;
    const shipmentId = `NewShipment${this.state.editBillsDataArray.length + 1}`;
    const newArray = [
      ...this.state.editBillsDataArray,
      {
        shipmentId: shipmentId,
        editInfo: getDefaultShipmentData({
          getProNumber: this.props.proValidation.getProNumber,
          proNumberLength,
          defaultCountry: this.props.configJSON.defaultCountry,
          stopData: this.props.stopData
        }),
        errorInfo: {
          packagingItemsErrorInfo: [{}],
        },
        openEditMode: true,
        initialDataExists: false,
        manualPro: true,
        pickupStatus: appConstants.PICKUP_STATUS.WAITING,
      },
    ];
    this.setState({
      editBillsDataArray: newArray,
      isAddProClicked: true,
    });
  };

  handelCancelClicked = (shipmentId) => {
    let newArray = [];
    this.state.editBillsDataArray.forEach((shipment) => {
      if (shipment.shipmentId === shipmentId) {
        if (shipment.isUpdatedAtLeastOnce || shipment.initialDataExists) {
          newArray.push(shipment);
        }
      } else {
        newArray.push(shipment);
      }
    });
    this.setState({
      editBillsDataArray: newArray,
      isAddProClicked: false,
    });
  };

  getFieldError = (field, value) => {
    switch (field) {
      case "arrivalTime":
        return value ? null : "* Required";
      case "departureTime":
        return this.getDepartureTimeError(value);
      default:
        return null;
    }
  };

  getErrorInfo = () => {
    let errorInfo = {};
    Object.keys(this.state.pickupInfo).forEach((fieldName) => {
      errorInfo[fieldName] = this.getFieldError(
        fieldName,
        this.state.pickupInfo[fieldName]
      );
    });
    this.setState({
      pickupErrorInfo: errorInfo,
    });
    return errorInfo;
  };

  onCancelStopCompletion = () => {
    this.setState({
      isIncompleteEntryExist: false,
    });
  };


  getShipmentHu = (pickedUpShipment) => {
    return (
      pickedUpShipment.packagingItems?.reduce(
        (hu, currPackage) => (hu || 0) + (parseInt(currPackage.hu) || 0),
        0
      ) ?? 0
    );
  };

  parseNumericValue = (value) => {
    const parsed = parseInt(value);
    return Number.isNaN(parsed) ? 0 : parsed;
  };

  getShipmentBadgeDetails = (pickupShipments) => {
    if (!pickupShipments?.length) {
      return { bills: '-', hu: '-', pieces: '-', weight: '-' };
    }

    const totals = pickupShipments.reduce(
      (acc, currShipment) => {
        const editInfo = currShipment.editInfo;
        return {
          hu: acc.hu + this.getShipmentHu(editInfo),
          pieces: acc.pieces + this.parseNumericValue(editInfo?.pieces),
          weight: acc.weight + this.parseNumericValue(editInfo?.weight)
        };
      },
      { hu: 0, pieces: 0, weight: 0 }
    );

    return {
      bills: pickupShipments.length,
      hu: totals.hu || '-',
      pieces: totals.pieces || '-',
      weight: totals.weight || '-'
    };
  };

  isOneProComplete = () => {
    return this.state.editBillsDataArray.some(
      (shipment) =>
        shipment.pickupStatus === appConstants.PICKUP_STATUS.COMPLETED
    );
  };

  getNoFreightCodes = () => {
    if (this.enableNoFreightCode) {
      return this.props.DispatchStore.staticClientData.clientCodes?.noFreightCode?.map(
        (noFreightCode) => {
          return { label: noFreightCode.description, value: noFreightCode.code };
        }
      );
    }
    return [];
  };

  handleIncompletePickupEntryConfirm = () => {
    const incompletePickups = getNoFreightPickupIds(this.state.editBillsDataArray);
    if(incompletePickups.length === 0) {
      this.completePickup();
    }else{
      this.setState(
        { incompletePickups : incompletePickups.map(pickupId => ({ pickupId })),
        },
        () => {        
          this.completePickup(true); // true because there are no freight shipments present
        }
      );
    }
  };

  handleNoFreightReasonSubmit = (incompletePickups) => {
    this.setState(
     { incompletePickups },
      () => {
        this.completePickup(true); // true because there are no freight shipments present
      }
    );
  };

  render() {
    const { classes, open, handleClose, stopData, routeData, isDriverArrived } =
      this.props;
    const {
      editBillsDataArray,
      isAddProClicked,
      pickupInfo: { isNoFreight },
      stopTimeInfo,
      pickupErrorInfo,
    } = this.state;
    const { theme } = this.props.userData.userProfile || {};
    const {
      accessorialList,
      priorityShipmentsList,
      packageTypeList,
      countryList,
      limitedAccessList,
    } = this;
    const shipmentBadgeDetails =
      this.getShipmentBadgeDetails(editBillsDataArray);
    
    const pickupIdToNumberMap = getPickupIdToNumberMap(stopData.shipments);
    const sortedShipmentsByPickupNumber = getSortedShipmentsByPickupNumber(editBillsDataArray);
    const isSLCDisabled = this.isOneProComplete();
    return (
      <React.Fragment>
        <Dialog
          aria-labelledby="customized-dialog-title"
          open={open}
          classes={{ paper: classes.dialog }}
          className={`${classes.dialogWrapper} ${theme}`}
        >
          <DialogTitle
            handleClose={handleClose}
            id="customized-dialog-title"
            className={classes.titleDivider}
          >
            <div>
            <span className={classes.stopName}>
              {this.modalMessage.TITLE}
            </span>
            </div>
          </DialogTitle>
          {this.state.showNoFreightReasonContent && (
            <NoFreightReasonDialogContent
              classes={classes}
              editBillsDataArray={editBillsDataArray}
              stopData={stopData}
              handleClose={handleClose}
              pickupIdToNumberMap={pickupIdToNumberMap}
              noFreightCodes={this.noFreightCodes}
              enableNoFreightCode={this.enableNoFreightCode}
              handleNoFreightReasonSubmit={this.handleNoFreightReasonSubmit}
            />
          )}
          {!this.state.showNoFreightReasonContent && (
            <>
              <DialogContent className="customScroll">
                <>
                  <PickupDetails
                    forwardRef={this.pickupDetailsRef}
                    stopData={stopData}
                    handleChange={this.handlePickupLevelData}
                    isShipperLoadAndCount={this.state.pickupInfo.isShipperLoadAndCount}
                    isNoFreight={isNoFreight}
                    pickupInfo={this.state.pickupInfo}
                    pickupErrorInfo={pickupErrorInfo}
                    isArrivalTimeDisabled={isDriverArrived}
                    stopTimeInfo={stopTimeInfo}
                    handleStopTimeChange={this.handleStopTimeChange}
                    isSLCDisabled={isSLCDisabled}
                    isReadOnly={this.props.isReadOnly}
                    noFreightCodes={this.noFreightCodes}
                    enableNoFreightCode={this.enableNoFreightCode}
                  />
                  {!isNoFreight && !isAddProClicked && (
                    <>
                      <div className={classes.manualEntryContainer}>
                        <span className={classes.manualEntryLabel}>Manual Pickup Entry</span>
                        <Button
                          autoFocus
                          color="primary"
                          variant="outlined"
                          className={classes.actionButton}
                          onClick={this.addPro}>
                          ADD A PRO
                        </Button>
                      </div>
                      <Divider className={classes.divider} />
                    </>
                  )}
                  <div>
                    <Typography variant="subtitle1" className={classes.headerLabel}>
                      PICKUP DETAILS
                    </Typography>
                    <ShipmentBadgeList
                      stopType={appConstants.STOP_TYPE.Pickup}
                      bills={shipmentBadgeDetails?.bills}
                      pieces={shipmentBadgeDetails?.pieces}
                      hu={shipmentBadgeDetails?.hu}
                      weight={shipmentBadgeDetails?.weight}
                    />
                  </div>
                  <div>
                    {sortedShipmentsByPickupNumber.length > 0 &&
                      sortedShipmentsByPickupNumber.map(({ shipment, pickupIndex }, index) => {
                        return (
                          <PickupShipmentCard
                            key={`pickup_shipmentCard${shipment.shipmentId}`}
                            index={index}
                            pickupIndex={pickupIndex}
                            editInfo={shipment.editInfo}
                            errorInfo={shipment.errorInfo}
                            shipmentId={shipment.shipmentId}
                            openEditMode={shipment.openEditMode}
                            initialDataExists={shipment.initialDataExists}
                            priorityShipmentsList={priorityShipmentsList}
                            packageTypeList={packageTypeList}
                            accessorialList={accessorialList}
                            countryList={countryList}
                            handleCancel={this.handelCancelClicked}
                            handleCompletePro={this.handleCompletePro}
                            pickupStatus={shipment.pickupStatus}
                            editProClicked={this.editProClicked}
                            isNoFreight={isNoFreight}
                            routeData={routeData}
                            limitedAccessList={limitedAccessList}
                            stopData={stopData}
                            proNumberLength={
                              this.props.DispatchStore.staticClientData?.clientCodes
                                ?.proNumberLength
                            }
                            consigneeList={this.state.consigneeList}
                            getExcessiveLengthMaxLimit={
                              this.props.DispatchStore.getExcessiveLengthMaxLimit
                            }
                            pickupIdToNumberMap={pickupIdToNumberMap}
                            completedProList={this.getCompletedPros().map(
                              ({ editInfo, shipmentId }) => ({
                                proNumber: editInfo.proNumber,
                                shipmentId
                              })
                            )}
                            isReadOnly={shipment.isCompletedPro || isNoFreight}
                          />
                        );
                      })}
                  </div>
                </>
              </DialogContent>
              <div className={classes.dialogFooter}>
                <DialogActions className={classes.dialogActionsClass}>
                  <PickupDialogActions
                    handleSubmit={this.handleSubmit}
                    handleClose={handleClose}
                    submitDisabled={this.isSubmitDisabled()}
                    isNoFreight={isNoFreight}
                  />
                </DialogActions>
              </div>
            </>
          )}
          
        </Dialog>
        {this.state.isIncompleteEntryExist && (
          <CustomConfirmationDialog
            title="Incomplete Pickup Entry"
            cancelButtonLabel="Complete Pro"
            confirmButtonLabel="Continue"
            onConfirm={this.handleIncompletePickupEntryConfirm} 
            onCancel={this.onCancelStopCompletion}
          >
            <div className={classes.confirmDialogContent}>
              <span>Whoops! There is an incomplete entry.</span>
              <span>
                Would you like to continue without completing remaining pickup
                entries?
              </span>
            </div>
          </CustomConfirmationDialog>
        )}
      </React.Fragment>
    );
  }
}

export default compose(
  withUserProfile,
  withStyles(styles),
  withSnackbar,
  withAppConfig
)(withProValidationHOC(ProcessPickupStopDialog));
